<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { NextButton },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations: {
    inboxName: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) return;

      try {
        const whatsappChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.inboxName,
            channel: {
              type: 'whatsapp',
              phone_number: `+evo-${Date.now().toString(16)}`,
              provider: 'evolution',
              provider_config: {},
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: whatsappChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message ||
            this.$t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="mt-4">
      <div
        class="p-4 mb-4 rounded-lg bg-n-amber-2 border border-n-amber-6 text-n-slate-12"
      >
        <p class="text-sm font-medium mb-1">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION.INFO_TITLE') }}
        </p>
        <p class="text-sm">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION.INFO_DESC') }}
        </p>
      </div>
    </div>

    <div class="mt-4">
      <label>
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION.INBOX_NAME.LABEL') }}
        <input
          v-model.trim="inboxName"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION.INBOX_NAME.PLACEHOLDER')
          "
          @blur="v$.inboxName.$touch"
        />
        <span v-if="v$.inboxName.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION.INBOX_NAME.ERROR') }}
        </span>
      </label>
    </div>

    <div class="mt-4 flex justify-end">
      <NextButton
        :disabled="v$.$invalid || uiFlags.isCreating"
        :loading="uiFlags.isCreating"
        @click="createChannel"
      >
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION.SUBMIT_BUTTON') }}
      </NextButton>
    </div>
  </div>
</template>
